import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Customer } from '@studio/types';

export const root = {};

export const id = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@id`,
    response: {} as Customer.Get.Customer,
    params: {} as { id: string },
    method: HTTP_METHODS.GET,
  },
};
